// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file groups_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyMessageResponseSchema, IdRequestSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { CustomGroupCreateSchema, CustomGroupListRequestSchema, CustomGroupListSchema, CustomGroupSchema, CustomGroupUpdateSchema, CustomGroupWithGrantsCreateSchema, CustomGroupWithGrantsSchema, GroupMembershipCreateSchema, GroupMembershipListRequestSchema, GroupMembershipListSchema, GroupMembershipSchema, GroupMembershipUpdateSchema, ResourceAccessGrantBulkOrganizationUpdateSchema, ResourceAccessGrantCreateSchema, ResourceAccessGrantListRequestSchema, ResourceAccessGrantListSchema, ResourceAccessGrantSchema, ResourceAccessGrantUpdateSchema } from "./groups_pb";
import { file_groups } from "./groups_pb";

/**
 * Describes the file groups_service.proto.
 */
export const file_groups_service: GenFile = /*@__PURE__*/
  fileDesc("ChRncm91cHNfc2VydmljZS5wcm90bxIJcmFjY29vbmFpMrMEChJDdXN0b21Hcm91cFNlcnZpY2USSQoRQ3JlYXRlQ3VzdG9tR3JvdXASHC5yYWNjb29uYWkuQ3VzdG9tR3JvdXBDcmVhdGUaFi5yYWNjb29uYWkuQ3VzdG9tR3JvdXASZwobQ3JlYXRlQ3VzdG9tR3JvdXBXaXRoR3JhbnRzEiYucmFjY29vbmFpLkN1c3RvbUdyb3VwV2l0aEdyYW50c0NyZWF0ZRogLnJhY2Nvb25haS5DdXN0b21Hcm91cFdpdGhHcmFudHMSPgoOR2V0Q3VzdG9tR3JvdXASFC5yYWNjb29uYWkuSWRSZXF1ZXN0GhYucmFjY29vbmFpLkN1c3RvbUdyb3VwEkkKEVVwZGF0ZUN1c3RvbUdyb3VwEhwucmFjY29vbmFpLkN1c3RvbUdyb3VwVXBkYXRlGhYucmFjY29vbmFpLkN1c3RvbUdyb3VwEk4KDUxpc3RPcmdHcm91cHMSIS5yYWNjb29uYWkuQ3VzdG9tR3JvdXBMaXN0UmVxdWVzdBoaLnJhY2Nvb25haS5DdXN0b21Hcm91cExpc3QSSgoRRGVsZXRlQ3VzdG9tR3JvdXASFC5yYWNjb29uYWkuSWRSZXF1ZXN0Gh8ucmFjY29vbmFpLkVtcHR5TWVzc2FnZVJlc3BvbnNlEkIKElJlc3RvcmVDdXN0b21Hcm91cBIULnJhY2Nvb25haS5JZFJlcXVlc3QaFi5yYWNjb29uYWkuQ3VzdG9tR3JvdXAy7AIKFkdyb3VwTWVtYmVyc2hpcFNlcnZpY2USTgoOQWRkVXNlclRvR3JvdXASIC5yYWNjb29uYWkuR3JvdXBNZW1iZXJzaGlwQ3JlYXRlGhoucmFjY29vbmFpLkdyb3VwTWVtYmVyc2hpcBJdChRMaXN0R3JvdXBNZW1iZXJzaGlwcxIlLnJhY2Nvb25haS5Hcm91cE1lbWJlcnNoaXBMaXN0UmVxdWVzdBoeLnJhY2Nvb25haS5Hcm91cE1lbWJlcnNoaXBMaXN0ElUKFVVwZGF0ZUdyb3VwTWVtYmVyc2hpcBIgLnJhY2Nvb25haS5Hcm91cE1lbWJlcnNoaXBVcGRhdGUaGi5yYWNjb29uYWkuR3JvdXBNZW1iZXJzaGlwEkwKE1JlbW92ZVVzZXJGcm9tR3JvdXASFC5yYWNjb29uYWkuSWRSZXF1ZXN0Gh8ucmFjY29vbmFpLkVtcHR5TWVzc2FnZVJlc3BvbnNlMoEEChpSZXNvdXJjZUFjY2Vzc0dyYW50U2VydmljZRJeChZHcmFudFJvbGVBY2Nlc3NUb1Njb3BlEiQucmFjY29vbmFpLlJlc291cmNlQWNjZXNzR3JhbnRDcmVhdGUaHi5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudBJgCg9MaXN0R3JvdXBHcmFudHMSKS5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudExpc3RSZXF1ZXN0GiIucmFjY29vbmFpLlJlc291cmNlQWNjZXNzR3JhbnRMaXN0EmEKGVVwZGF0ZVJlc291cmNlQWNjZXNzR3JhbnQSJC5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudFVwZGF0ZRoeLnJhY2Nvb25haS5SZXNvdXJjZUFjY2Vzc0dyYW50EngKHEJ1bGtVcGRhdGVHcmFudHNPcmdhbml6YXRpb24SNC5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudEJ1bGtPcmdhbml6YXRpb25VcGRhdGUaIi5yYWNjb29uYWkuUmVzb3VyY2VBY2Nlc3NHcmFudExpc3QSRAoLUmV2b2tlR3JhbnQSFC5yYWNjb29uYWkuSWRSZXF1ZXN0Gh8ucmFjY29vbmFpLkVtcHR5TWVzc2FnZVJlc3BvbnNlQgZaBC4vcGI", [file_general, file_groups]);

/**
 * --- Custom Group Service ---
 *
 * @generated from service raccoonai.CustomGroupService
 */
export const CustomGroupService: GenService<{
  /**
   * @generated from rpc raccoonai.CustomGroupService.CreateCustomGroup
   */
  createCustomGroup: {
    methodKind: "unary";
    input: typeof CustomGroupCreateSchema;
    output: typeof CustomGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.CustomGroupService.CreateCustomGroupWithGrants
   */
  createCustomGroupWithGrants: {
    methodKind: "unary";
    input: typeof CustomGroupWithGrantsCreateSchema;
    output: typeof CustomGroupWithGrantsSchema;
  },
  /**
   * @generated from rpc raccoonai.CustomGroupService.GetCustomGroup
   */
  getCustomGroup: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof CustomGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.CustomGroupService.UpdateCustomGroup
   */
  updateCustomGroup: {
    methodKind: "unary";
    input: typeof CustomGroupUpdateSchema;
    output: typeof CustomGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.CustomGroupService.ListOrgGroups
   */
  listOrgGroups: {
    methodKind: "unary";
    input: typeof CustomGroupListRequestSchema;
    output: typeof CustomGroupListSchema;
  },
  /**
   * @generated from rpc raccoonai.CustomGroupService.DeleteCustomGroup
   */
  deleteCustomGroup: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
  /**
   * revives the group with the members and grants its deletion removed
   *
   * @generated from rpc raccoonai.CustomGroupService.RestoreCustomGroup
   */
  restoreCustomGroup: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof CustomGroupSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_groups_service, 0);

/**
 * --- Group Membership Service ---
 *
 * @generated from service raccoonai.GroupMembershipService
 */
export const GroupMembershipService: GenService<{
  /**
   * @generated from rpc raccoonai.GroupMembershipService.AddUserToGroup
   */
  addUserToGroup: {
    methodKind: "unary";
    input: typeof GroupMembershipCreateSchema;
    output: typeof GroupMembershipSchema;
  },
  /**
   * @generated from rpc raccoonai.GroupMembershipService.ListGroupMemberships
   */
  listGroupMemberships: {
    methodKind: "unary";
    input: typeof GroupMembershipListRequestSchema;
    output: typeof GroupMembershipListSchema;
  },
  /**
   * @generated from rpc raccoonai.GroupMembershipService.UpdateGroupMembership
   */
  updateGroupMembership: {
    methodKind: "unary";
    input: typeof GroupMembershipUpdateSchema;
    output: typeof GroupMembershipSchema;
  },
  /**
   * @generated from rpc raccoonai.GroupMembershipService.RemoveUserFromGroup
   */
  removeUserFromGroup: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_groups_service, 1);

/**
 * --- Resource Access Grant Service ---
 *
 * @generated from service raccoonai.ResourceAccessGrantService
 */
export const ResourceAccessGrantService: GenService<{
  /**
   * @generated from rpc raccoonai.ResourceAccessGrantService.GrantRoleAccessToScope
   */
  grantRoleAccessToScope: {
    methodKind: "unary";
    input: typeof ResourceAccessGrantCreateSchema;
    output: typeof ResourceAccessGrantSchema;
  },
  /**
   * @generated from rpc raccoonai.ResourceAccessGrantService.ListGroupGrants
   */
  listGroupGrants: {
    methodKind: "unary";
    input: typeof ResourceAccessGrantListRequestSchema;
    output: typeof ResourceAccessGrantListSchema;
  },
  /**
   * @generated from rpc raccoonai.ResourceAccessGrantService.UpdateResourceAccessGrant
   */
  updateResourceAccessGrant: {
    methodKind: "unary";
    input: typeof ResourceAccessGrantUpdateSchema;
    output: typeof ResourceAccessGrantSchema;
  },
  /**
   * @generated from rpc raccoonai.ResourceAccessGrantService.BulkUpdateGrantsOrganization
   */
  bulkUpdateGrantsOrganization: {
    methodKind: "unary";
    input: typeof ResourceAccessGrantBulkOrganizationUpdateSchema;
    output: typeof ResourceAccessGrantListSchema;
  },
  /**
   * @generated from rpc raccoonai.ResourceAccessGrantService.RevokeGrant
   */
  revokeGrant: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_groups_service, 2);

